// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1NMPJ","title":"ClientCherryInfo_title__3bMbf","itemText":"ClientCherryInfo_itemText__3I1zb"};